import { render, staticRenderFns } from "./_openingBalance.vue?vue&type=template&id=e56fb7da&scoped=true&"
import script from "./_openingBalance.vue?vue&type=script&lang=js&"
export * from "./_openingBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56fb7da",
  null
  
)

export default component.exports